import { checkZip } from 'app/actions';
import { apiCall } from 'app/dealer/actions';

import * as ActionTypes from './constants';
import { paymentMethodSteps } from './utils';

export const checkSepaZip = zip => {
  return dispatch => {
    dispatch({ type: ActionTypes.CHECK_SEPA_ZIP_REQUEST });

    return dispatch(checkZip(zip))
      .then(() => {
        return dispatch({
          type: ActionTypes.CHECK_SEPA_ZIP_SUCCESS,
          payload: zip,
        });
      })
      .catch(() => {
        return dispatch({
          type: ActionTypes.CHECK_SEPA_ZIP_FAILURE,
          payload: zip,
        });
      });
  };
};

export const checkSepaBic = bic => {
  const url = '/dealer-portal/validations/bic';
  const request = {
    method: 'POST',
    body: JSON.stringify({ bic }),
  };

  return dispatch => {
    dispatch({
      type: ActionTypes.CHECK_SEPA_BIC_REQUEST,
    });

    return dispatch(apiCall(url, request))
      .then(() => {
        return dispatch({
          type: ActionTypes.CHECK_SEPA_BIC_SUCCESS,
        });
      })
      .catch(() => {
        return dispatch({
          type: ActionTypes.CHECK_SEPA_BIC_FAILURE,
        });
      });
  };
};

export const checkSepaIban = iban => {
  const url = '/dealer-portal/validations/iban';
  const request = {
    method: 'POST',
    body: JSON.stringify({ iban }),
  };

  return dispatch => {
    dispatch({
      type: ActionTypes.CHECK_SEPA_IBAN_REQUEST,
    });

    return dispatch(apiCall(url, request))
      .then(payload => {
        return dispatch({
          type: ActionTypes.CHECK_SEPA_IBAN_SUCCESS,
          payload,
        });
      })
      .catch(() => {
        return dispatch({
          type: ActionTypes.CHECK_SEPA_IBAN_FAILURE,
        });
      });
  };
};

export const setPaymentMethod = paymentMethod => {
  return {
    type: ActionTypes.SET_PAYMENT_METHOD,
    payload: paymentMethod,
  };
};

export const setPaymentMethodStep = paymentMethodStep => {
  return {
    type: ActionTypes.SET_PAYMENT_METHOD_STEP,
    payload: paymentMethodStep,
  };
};

export const updateSepaMandate = payload => {
  return {
    type: ActionTypes.UPDATE_SEPA_MANDATE,
    payload,
  };
};

export const submitSepaMandate = () => {
  return (dispatch, getState) => {
    const state = getState();
    const {
      paymentMethod: { sepaMandate },
    } = state;
    const url = '/dealer-portal/sepa-mandates';
    const { SEPA_BRANCH_ASSIGNMENT, SEPA_MANDATE } = paymentMethodSteps;
    const request = {
      method: 'POST',
      body: JSON.stringify(sepaMandate),
    };

    dispatch({
      type: ActionTypes.SUBMIT_SEPA_MANDATE_REQUEST,
    });

    return dispatch(apiCall(url, request))
      .then(payload => {
        dispatch({
          type: ActionTypes.SUBMIT_SEPA_MANDATE_SUCCESS,
          payload,
        });

        return dispatch({
          type: ActionTypes.SET_PAYMENT_METHOD_STEP,
          payload: SEPA_BRANCH_ASSIGNMENT,
        });
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.SUBMIT_SEPA_MANDATE_FAILURE,
          error,
        });

        return dispatch({
          type: ActionTypes.SET_PAYMENT_METHOD_STEP,
          payload: SEPA_MANDATE,
        });
      });
  };
};

export const updateSepaBranchAssignment = ({ id, isSelected }) => {
  return dispatch => {
    dispatch({
      type: ActionTypes.UPDATE_SEPA_BRANCH_ASSIGNMENT,
      payload: { id, isSelected },
    });
  };
};

export const toggleSepaAllBranchAssignment = (branchIds, select) => {
  return dispatch => {
    dispatch({
      type: ActionTypes.UPDATE_SEPA_ALL_BRANCHES_ASSIGNMENT,
      payload: {
        branchIds,
        select,
      },
    });
  };
};

export const submitSepaBranchAssignment = (passedSepaId, passedDealerIds) => {
  return (dispatch, getState) => {
    const url = '/dealer-portal/dealers/payment-method/assign';
    const state = getState();
    const { SEPA_COMPLETED } = paymentMethodSteps;
    const {
      paymentMethod: {
        paymentMethod,
        sepaBranchAssignments: dealerIds,
        sepaMandate: { id: sepaMandateId },
      },
    } = state;
    const paymentMethodType =
      paymentMethod === 'SEPA' ? 'sepa_direct_debit' : 'bank_transfer';
    const body = {
      dealerIds: passedDealerIds || dealerIds,
      paymentMethodType,
    };

    if (paymentMethodType === 'sepa_direct_debit') {
      body.sepaMandateId = passedSepaId || sepaMandateId;
    }

    const request = {
      method: 'PUT',
      body: JSON.stringify(body),
    };

    dispatch({
      type: ActionTypes.SUBMIT_SEPA_BRANCH_ASSIGNMENT_REQUEST,
    });

    return dispatch(apiCall(url, request))
      .then(() => {
        dispatch({
          type: ActionTypes.SUBMIT_SEPA_BRANCH_ASSIGNMENT_SUCCESS,
        });
        dispatch({
          type: ActionTypes.SET_PAYMENT_METHOD_STEP,
          payload: SEPA_COMPLETED,
        });
      })
      .catch(error => {
        dispatch({
          type: ActionTypes.SUBMIT_SEPA_BRANCH_ASSIGNMENT_FAILURE,
          error,
        });
      });
  };
};

export const resetPaymentMethod = () => {
  return {
    type: ActionTypes.RESET_PAYMENT_METHOD,
  };
};
